import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/d1258bca-11d1-47e1-ad0e-de5fcc307b27";
export const REGISTER_URL = "https://a.ntrk2.com/a5f73296-b417-498f-92ff-33434f985044";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://allwinph.loadprkw2a.com/download?openExternalBrowser=1&id=z3b3bse1o54wtpp";

export * from "./codes";
export * from "./context";
